import useTranslator from "@pma/hooks/use-translator"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/common/tooltip"
import { Button } from "@components/common/button"
import { DictType } from "@pma/types"
import { toast } from "@pma/hooks/use-toast"
import { Copy } from "lucide-react"

interface Props {
  file?: DictType
  fileArr?: DictType[]
  setCopyFiles: (files: DictType[]) => void
  handleBatchSelection?: () => void
  isMenuView?: boolean
}

const CopyFile = ({ file, fileArr, setCopyFiles, handleBatchSelection, isMenuView }: Props) => {
  const { translate } = useTranslator()

  const handleCopyFile = () => {
    if (file) {
      setCopyFiles([file])
    } else if (fileArr && fileArr.length > 0) {
      setCopyFiles(fileArr)
      if (handleBatchSelection) {
        handleBatchSelection()
      }
    }

    toast({
      title: translate("Success"),
      description: translate("Your file has been copy"),
      variant: "success",
    })
  }

  return isMenuView ? (
    <div className='flex items-center gap-2 rounded hover:bg-muted' onClick={handleCopyFile}>
      <div className='px-2'>
        <Copy size={16} />
      </div>
      <span className='text-sm'>{translate("Copy file")}</span>
    </div>
  ) : (
    <Tooltip>
      <TooltipTrigger asChild>
        {file ? (
          <Button size='icon' className='h-6 w-7' variant='ghost' onClick={handleCopyFile}>
            <Copy className='h-4 w-4' />
          </Button>
        ) : (
          <Button
            variant='outline'
            size='sm'
            onClick={handleCopyFile}
            disabled={!fileArr || fileArr.length === 0}
            className='flex items-center gap-1'
          >
            <Copy size={14} />
            <span className='hidden min-w-[30px] text-left text-[12px] sm:block sm:text-[10px]'>
              {translate("Copy selected files")}
            </span>
          </Button>
        )}
      </TooltipTrigger>
      <TooltipContent>
        {file ? translate("Copy file") : translate("Copy selected files")}
      </TooltipContent>
    </Tooltip>
  )
}

export default CopyFile
